export default "__VITE_ASSET__BJITYV9w__"